import { Map } from 'immutable';
import { createReducer } from 'redux-act';

import EnableGuestWebResult from '../../models/interfaces/EnableGuestWebResult';
import { enableGuestWebFailed, enableGuestWebFinished } from '../actions/place/enableGuestWeb';

export interface EnableGuestWebState {
  readonly enableGuestWebResults: Map<string, { enableGuestWebResult: EnableGuestWebResult }>;
}

const defaultState: EnableGuestWebState = {
  enableGuestWebResults: Map(),
};

const enableGuestWebReducer = createReducer<EnableGuestWebState>({}, defaultState);

enableGuestWebReducer.on(enableGuestWebFinished, (state, { enableGuestWebResult, token }) => {
  const { enableGuestWebResults, ...others } = state;
  return { ...others, enableGuestWebResults: enableGuestWebResults.set(token, { enableGuestWebResult }) };
});

enableGuestWebReducer.on(enableGuestWebFailed, (state, { enableGuestWebResult, token }) => {
  const { enableGuestWebResults, ...others } = state;
  return { ...others, enableGuestWebResults: enableGuestWebResults.set(token, { enableGuestWebResult }) };
});

export default enableGuestWebReducer;
